import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from "@angular/core";

import { WithConfig } from "ng-zorro-antd/core/config";
import { NzDestroyService } from "ng-zorro-antd/core/services";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzFilterTriggerComponent } from "ng-zorro-antd/table";
import { UiDropdownMenuComponent } from "@webapp/ui/dropdown/components/dropdown-menu/dropdown-menu.component";
import { UiDropDownDirective } from "@webapp/ui/dropdown/dropdown.directive";

@Component({
  selector: "ui-filter-trigger",
  exportAs: `uiFilterTrigger`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "filter-trigger.component.html",
  providers: [NzDestroyService],
})
export class UiFilterTriggerComponent extends NzFilterTriggerComponent {
  @Input("uiActive") public nzActive = false;
  @Input("uiDropdownMenu") public nzDropdownMenu!: UiDropdownMenuComponent;
  @Input("uiVisible") public nzVisible = false;

  /**
   * @deprecated Not supported, use `nzBackdrop` instead.
   * @breaking-change 13.0.0
   */
  @Input("uiHasBackdrop") @InputBoolean() public nzHasBackdrop = false;
  @Input("uiBackdrop") @WithConfig<boolean>() @InputBoolean() public nzBackdrop = false;

  @Output("uiVisibleChange") public readonly nzVisibleChange = new EventEmitter<boolean>();

  @ViewChild(UiDropDownDirective, { static: true, read: ElementRef }) public nzDropdown!: ElementRef<HTMLElement>;
}
